"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hr = exports.ScreenReaderOnly = exports.Hide = exports.Show = exports.Contained = exports.Section = exports.Grid = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _functions = require("../functions");
var _polished = require("polished");
var _mediaGenerator = _interopRequireDefault(require("@berlitz/max-utils/lib/mediaGenerator"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/* eslint-disable prettier/prettier */
var Grid = _styledComponents.default.div.withConfig({
  displayName: "layout__Grid",
  componentId: "sc-1v1f22p-0"
})(["width:100%;max-width:", ";padding:", ";margin:0 auto;@media (min-width:", "){padding:", ";}"], function (_ref) {
  var theme = _ref.theme,
    fullWidth = _ref.fullWidth;
  return !fullWidth && "".concat((0, _functions.calculateMaxWidth)(theme.gridWidth, theme.layout.xxs), "px");
}, function (_ref2) {
  var theme = _ref2.theme;
  return "0 ".concat(theme.space.lg);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "0 ".concat(theme.space.md);
});
exports.Grid = Grid;
var Section = _styledComponents.default.section.withConfig({
  displayName: "layout__Section",
  componentId: "sc-1v1f22p-1"
})(["background-color:", ";padding:", " 0;", "   ", " ", " @media (min-width:", "){padding:", " 0;", " ", "}"], function (_ref5) {
  var theme = _ref5.theme,
    backgroundColor = _ref5.backgroundColor;
  return backgroundColor ? theme.section.backgroundColor[backgroundColor] : theme.section.backgroundColor.default;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.xl;
}, function (_ref7) {
  var disablePaddingTop = _ref7.disablePaddingTop;
  return disablePaddingTop && (0, _styledComponents.css)(["padding-top:0;"]);
}, function (_ref8) {
  var disablePaddingBottom = _ref8.disablePaddingBottom;
  return disablePaddingBottom && (0, _styledComponents.css)(["padding-bottom:0;"]);
}, function (_ref9) {
  var alignCenter = _ref9.alignCenter;
  return alignCenter && (0, _styledComponents.css)(["text-align:center;[data-key=\"max-rich-text\"]{display:flex;flex-direction:column;justify-content:center;align-items:center;}"]);
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.sm;
}, function (_ref11) {
  var theme = _ref11.theme,
    _ref11$size = _ref11.size,
    size = _ref11$size === void 0 ? 'md' : _ref11$size;
  return theme.layout[size];
}, function (_ref12) {
  var disablePaddingTop = _ref12.disablePaddingTop;
  return disablePaddingTop && (0, _styledComponents.css)(["padding-top:0;"]);
}, function (_ref13) {
  var disablePaddingBottom = _ref13.disablePaddingBottom;
  return disablePaddingBottom && (0, _styledComponents.css)(["padding-bottom:0;"]);
});
exports.Section = Section;
var Contained = _styledComponents.default.div.withConfig({
  displayName: "layout__Contained",
  componentId: "sc-1v1f22p-2"
})(["margin:0 auto;max-width:", ";"], function (_ref14) {
  var theme = _ref14.theme,
    maxWidth = _ref14.maxWidth;
  return theme.breakpoints[maxWidth];
});
exports.Contained = Contained;
var Show = _styledComponents.default.span.withConfig({
  displayName: "layout__Show",
  componentId: "sc-1v1f22p-3"
})(["display:none;", ";"], function (_ref15) {
  var theme = _ref15.theme,
    breaks = _ref15.breaks;
  return (0, _mediaGenerator.default)(theme, breaks, 'display: flex;');
});
exports.Show = Show;
var Hide = _styledComponents.default.span.withConfig({
  displayName: "layout__Hide",
  componentId: "sc-1v1f22p-4"
})(["display:inline-flex;", ";"], function (_ref16) {
  var theme = _ref16.theme,
    breaks = _ref16.breaks;
  return (0, _mediaGenerator.default)(theme, breaks, 'display: none;');
});
exports.Hide = Hide;
var ScreenReaderOnly = _styledComponents.default.span.withConfig({
  displayName: "layout__ScreenReaderOnly",
  componentId: "sc-1v1f22p-5"
})(["", ";"], (0, _polished.hideVisually)());
exports.ScreenReaderOnly = ScreenReaderOnly;
var Hr = _styledComponents.default.hr.withConfig({
  displayName: "layout__Hr",
  componentId: "sc-1v1f22p-6"
})(["border:0;border-top:solid 1px ", ";margin:", " 0;padding-bottom:", "px;height:1px;"], function (_ref17) {
  var theme = _ref17.theme,
    light = _ref17.light;
  return light ? theme.palette.blue50 : theme.palette.gray40;
}, function (_ref18) {
  var theme = _ref18.theme,
    size = _ref18.size;
  return theme.space[size];
}, function (_ref19) {
  var theme = _ref19.theme,
    offset = _ref19.offset;
  return (0, _polished.stripUnit)(theme.space[offset]) * 2;
});
exports.Hr = Hr;